import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { AssessmentService } from '../../services/assessment-service/assessment.service';
import { AuthenticationService } from '../../services/authentication-service/authentication.service';
import { UserContextService } from '../../services/user-context-service/user-context.service';
import { UtilService } from '../../services/util-service/util.service';
import { ErrorModalComponent } from '../../dialogs/error-modal';

@Component({
  selector: 'app-sign',
  templateUrl: './sign.component.html',
  imports: [RouterModule, TranslateModule],
})
export class SignComponent implements OnInit {
  iframeSrc: SafeResourceUrl;
  activeAssessmentId: string = '';
  language: string = 'en';
  insuredPersonFullName: string;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly config: AppConfigService,
    private readonly assessmentService: AssessmentService,
    private readonly translateService: TranslateService,
    private readonly utils: UtilService,
    private readonly sanitizer: DomSanitizer,
    private readonly modalService: NgbModal,
    public route: ActivatedRoute,
    private readonly userContextService: UserContextService,
    private readonly router: Router
  ) {
    this.iframeSrc = sanitizer.bypassSecurityTrustResourceUrl('');
  }

  ngOnInit(): void {
    this.activeAssessmentId = this.route.snapshot.paramMap.get('assessmentId');
    this.language = this.route.snapshot.paramMap.get('lang');
    this.authenticationService
      .getSignPath(this.assessmentService.getCurrentAssessmentWrapperId(), this.translateService.currentLang)
      .subscribe({
        next: signPath => {
          if (this.config.configData.externalSign) {
            window.location.assign(signPath);
          } else {
            this.iframeSrc = this.utils.handleIFrameUrl(signPath);
          }
        },
        error: error => {
          if (error.message === 'rspErrorAssessmentNotFound') {
            this.router.navigate(['/initial-information']).then();
          }
        },
        complete: () => {},
      });
    this.route.queryParams.subscribe(p => {
      if (p?.error) {
        this.showErrorModal(p.error);
      }
    });
    this.insuredPersonFullName = this.userContextService.getInsuredPersonFullNameForAssessmentWrapper(
      this.assessmentService.getCurrentAssessmentWrapperId()
    );
  }

  showErrorModal(modalBodyKey: string): NgbModalRef {
    let modal: NgbModalRef = this.modalService.open(ErrorModalComponent, {
      ariaLabelledBy: 'error-modal-title',
      ariaDescribedBy: 'error-modal-body',
    });
    modal.componentInstance.modalBodyKey = modalBodyKey;
    modal.componentInstance.modalTitleKey = 'rspModalGeneralHeading';
    modal.componentInstance.modalButtonCloseKey = 'rspModalButtonClose';
    return modal;
  }
}
